import { Component, Story } from './DocTypes';

const SWCharacterFinderStory: Story = {
  title: 'Star Wars character finder',
  description: 'A tag-http character list',
  coreComponent: {
    html: `<tag-http request-events='load,search' path='https://swapi.dev/api/people/?search={{search}}'>
  <tag-search placeholder='Search for a Star Wars character'>
      <tag-list>
        <template>
          <style>
              .star-wars-list-item {
                  display: inline-flex;
                  align-items: center;
                  width: 100%
              }

              .star-wars-character-name-container {
                  width: 40%;
              }

              .star-wars-character-details-container {
                  margin-left: auto;
              }

              .star-wars-popover-container {
                  padding: 10px;
                  width: 480px
              }

              .star-wars-popover-col-1 {
                  display: inline-block;
                  vertical-align: top;
                  width: 220px;
              }

              .star-wars-popover-col-2 {
                  display: inline-block;
                  vertical-align: top;
                  width: 220px;
                  margin-left: 20px;
                  margin-top: 30px;
              }
          </style>
          <div class="star-wars-list-item">
              <div>
                  <tag-icon icon="CircleStar" size="50" accent="dark-green"></tag-icon>
              </div>
              <div class="star-wars-character-name-container">
                  <tag-field value="{{name}}" value-style='{"font-size": "18px"}'></tag-field>
              </div>
              <div>
                  <tag-button icon='Chat' squared class="star-wars-popover"></tag-button>
              </div>
              <div class="star-wars-character-details-container">
                  <tag-field label="Height:" label-style='{"margin-right": "5px", "white-space": "nowrap", "width": "50px"}' value="{{height}}"></tag-field>
                  <tag-field label="Mass:" label-style='{"margin-right": "5px", "white-space": "nowrap", "width": "50px"}' value="{{mass}}"></tag-field>
              </div>
          </div>
          <tag-popover popover-for=".star-wars-popover">
              <div class="star-wars-popover-container">
                  <div class="star-wars-popover-col-1">
                      <tag-field value="{{name}}" value-style='{"font-size": "24px", "margin-bottom": "15px"}'></tag-field>
                      <tag-field label="Date of Birth" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="{{birth_year}}"></tag-field>
                      <tag-field label="Height" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="{{height}}"></tag-field>
                      <tag-field label="mass" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="{{mass}}"></tag-field>
                      <tag-field label="Gender" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="{{gender}}"></tag-field>
                  </div>
                  <div class="star-wars-popover-col-2">
                      <tag-field label="Hair Colour" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="{{hair_color}}"></tag-field>
                      <tag-field label="Skin Colour" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="{{skin_color}}"></tag-field>
                      <tag-field label="Eye Colour" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="{{eye_color}}"></tag-field>
                  </div>
              </div>
          </tag-popover>
        </template>
      </tag-list>
  </tag-search>
</tag-http>
`,
  },
  reactWrapper: {
    jsx: `<TagHttp requestEvents='load,search' path='https://swapi.dev/api/people/?search={{search}}'>
  <TagSearch placeholder='Search for a Star Wars character'>
      <TagList
      primaryField="name"
      keyField="name"
      listContainerStyle={{padding:'0px'}}
      renderItem={ item =>
        <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        width: '100%'}}
        >
          <div>
              <TagIcon icon="CircleStar" size="50" accent="dark-green"/>
          </div>
          <div style={{ width: '40%'}}>
              <TagField value={item.name} valueStyle={{"fontSize": "18px"}}/>
          </div>
          <div>
              <TagButton icon='Chat' squared className="star-wars-popover"/>
          </div>
          <div style={{marginLeft: 'auto'}}>
              <TagField label="Height:" labelStyle={{"marginRight": "5px", "whiteSpace": "nowrap", "width": "50px"}} value={item.height}/>
              <TagField label="Mass:" labelStyle={{"marginRight": "5px", "whiteSpace": "nowrap", "width": "50px"}} value={item.mass}/>
          </div>
          <TagPopover popoverFor=".star-wars-popover">
              <div style={{padding: '10px', width: '480px'}}>
                <div style={{display: 'inline-block', verticalAlign: 'top', width: '220px'}}>
                    <TagField value={item.name} valueStyle={{"fontSize": "24px", "marginBottom": "15px"}}/>
                    <TagField label="Date of Birth" labelStyle={{"width": "100px", "whiteSpace": "nowrap", "fontWeight": "bold"}} value={item.birth_year}/>
                    <TagField label="Height" labelStyle={{"width": "100px", "whiteSpace": "nowrap", "fontWeight": "bold"}} value={item.height}/>
                    <TagField label="mass" labelStyle={{"width": "100px", "whiteSpace": "nowrap", "fontWeight": "bold"}} value={item.mass}/>
                    <TagField label="Gender" labelStyle={{"width": "100px", "whiteSpace": "nowrap", "fontWeight": "bold"}} value={item.gender}/>
                </div>
                <div style={{ display: 'inline-block', verticalAlign: 'top', width: '220px', marginLeft: '20px', marginTop: '30px',}}>
                    <TagField label="Hair Colour" labelStyle={{"width": "100px", "whiteSpace": "nowrap", "fontWeight": "bold"}} value={item.hair_color}/>
                    <TagField label="Skin Colour" labelStyle={{"width": "100px", "whiteSpace": "nowrap", "fontWeight": "bold"}} value={item.skin_color}/>
                    <TagField label="Eye Colour" labelStyle={{"width": "100px", "whiteSpace": "nowrap", "fontWeight": "bold"}} value={item.eye_color}/>
                </div>
              </div>
          </TagPopover>
      </div>
      }
      />
  </TagSearch>
</TagHttp>`,
  },
};

const SWDropDownStory: Story = {
  title: 'Star Wars Drop Down and Response Mapper',
  description: 'A tag-http character drop-down',
  coreComponent: {
    html: `<tag-http request-events='responseMapperAttached' path='https://swapi.dev/api/people/'>
  <tag-edit-field label='Choose your favourite Star Wars character' editor='dropdown'>
  </tag-edit-field>
</tag-http>`,
    js: `var tagHttp = document.querySelector('tag-http');
tagHttp.componentOnReady().then(function() {
  tagHttp.setRequestHeader('Accept-Language', 'en-US');
  tagHttp.responseMapper = function(response) {
    var body = response && response.body;
    var data = [];
    if (body && body.results && body.results.length > 0) {
      data = body.results.map(function(item) {
        return {
          label: item.name,
          value: item.name,
        };
      });
    }
    return {
      body: data,
    };
  };
});`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    setTimeout(()=>{
      var tagHttp = document.querySelector('tag-http');
      tagHttp.componentOnReady().then(function() {
        tagHttp.setRequestHeader('Accept-Language', 'en-US');
        tagHttp.responseMapper = function(response) {
          var body = response && response.body;
          var data = [];
          if (body && body.results && body.results.length > 0) {
            data = body.results.map(function(item) {
              return {
                label: item.name,
                value: item.name,
              };
            });
          }
          return {
            body: data,
          };
        };
      });
    },200);
    return (
      <TagHttp requestEvents='responseMapperAttached' path='https://swapi.dev/api/people/'>
        <TagEditField label='Choose your favourite Star Wars character' editor='dropdown'/>
      </TagHttp>
    )
  };`,
  },
};

const AccessTokenStory: Story = {
  title: 'Access token',
  description:
    'Gets an up-to-date access token for each request. Look in DevTools at the network pane to verify that the access token in the request is refreshed',
  coreComponent: {
    html: `<tag-http request-events='search' path='https://swapi.dev/api/people/?search={{search}}'>
  <tag-search placeholder='Search for a Star Wars character'>
    <tag-list primary-field="name"></tag-list>
  </tag-search>
</tag-http>`,
    js: `var i = 0
function getAccessToken() {
  return new Promise(function(resolve) {
    setTimeout(function () {
      i++;
      resolve("token" + i)
    }, 300);
  });
}

function requestMapper(request) {
  return new Promise(function (resolve) {
    getAccessToken().then(function (accessToken) {
      request.headers.set("Authorization", "bearer " + accessToken);
      resolve(request);
    });
  });
};

var http = document.querySelector("tag-http");
http.requestMapper = requestMapper;

`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `let i = 0;
  function getAccessToken() {
    return new Promise(function(resolve) {
      setTimeout(function () {
        i++;
        resolve("token" + i)
      }, 300);
    });
  }

  const Example = () => {
    const requestMapper = async (request) => {
      const accessToken = await getAccessToken();
      request.headers.set("Authorization", "bearer " + accessToken);
      return request;
    };
    return (
      <TagHttp
        requestEvents='search'
        path='https://swapi.dev/api/people/?search={{search}}'
        requestMapper={requestMapper}
      >
        <TagSearch placeholder='Search for a Star Wars character'>
          <TagList primaryField="name" />
        </TagSearch>
      </TagHttp>
    )
  }`,
  },
};

const ResponseMapperStory: Story = {
  title: 'Response mapper',
  description:
    'A response mapper function can map data so that it can be appropriately bound to UI elements',
  coreComponent: {
    html: `<tag-http path="https://api.carbonintensity.org.uk/intensity" response-type="object">
  <tag-data-binder hide-children-when-no-data>
    <tag-card version="2" style="width:300px;">
      <div style="text-align: center; padding: 10px 30px;">
        <tag-text type="h3" text="{{dateRange}}"></tag-text>
        <tag-text text="{{index}}" text-style='{{indexStyle}}'></tag-text>
        <div style="display: flex;margin-top: 10px;">
          <div style="display: flex; align-items: center;">
            <tag-text type="edit-field-label" text="Forecast:" text-style='{"display": "inline-block", "padding-bottom": "0px"}'></tag-text>
            <tag-text type="span" text="{{forecast}}"></tag-text>
          </div>
          <div style="display: flex; margin-left: auto; align-items: center;">
            <tag-text type="edit-field-label" text="Actual:" text-style='{"display": "inline-block", "padding-bottom": "0px"}'></tag-text>
            <tag-text type="span" text="{{actual}}"></tag-text>
          </div>
        </div>
      </div>
    </tag-card>
  </tag-data-binder>
</tag-http>
`,
    js: `var http = document.querySelector("tag-http");
http.componentOnReady().then(function() {
  http.responseMapper = function(response) {
    var body = response && response.body;
    var newBody;
    if (body && body.data && body.data.length > 0) {
      newBody = {
        dateRange:
          new Date(body.data[0].from).toLocaleDateString("en-GB") +
          " - " +
          new Date(body.data[0].to).toLocaleDateString("en-GB"),
        forecast: body.data[0].intensity
          ? body.data[0].intensity.forecast
          : 0,
        actual: body.data[0].intensity ? body.data[0].intensity.actual : 0,
        index: body.data[0].intensity ? body.data[0].intensity.index : ""
      };
      newBody.indexStyle =
        newBody.index === "moderate"
        ? '{"background-color": "#f9a411", "color": "white", "padding": "3px", "border-radius": "3px", "margin-bottom": "5px"}'
        : newBody.index === "high" || newBody.index === "very high"
          ? '{"background-color": "#e5173f", "color": "white", "padding": "3px", "border-radius": "3px", "margin-bottom": "5px"}'
          : '{"background-color": "#009999","color": "white", "padding": "3px", "border-radius": "3px", "margin-bottom": "5px"}';
    }
    response.body = newBody;
    return response;
  };
});`,
  },
};

export const TagHttpDocs: Component = {
  type: 'component',
  name: 'http',
  description: 'Makes a request to a web API',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'requestEvents',
      description:
        'Determines when the http request is made. The request is made when the component loads by default. The available events are load, responseMapperAttached, headersAdded, headersCleared, submit, search, pageRequest, click, refresh. This prop can take a comma delimited list of event names where multiple events should trigger the request',
      type:
        'load | responseMapperAttached | headersAdded | submit | search | pageRequest | click | refresh',
      default: 'load',
    },
    {
      name: 'method',
      description: 'The http method to use in the http request',
      type: 'string',
    },
    {
      name: 'path',
      description: 'The http path to use in the http request',
      type: 'string',
    },
    {
      name: 'displayError',
      description: 'Whether any error messages are output',
      type: 'boolean',
    },
    {
      name: 'responseType',
      description: 'Whether the expected response is an array or an object',
      type: 'object | array',
      default: 'array',
    },
    {
      name: 'noHeaders',
      description: 'Whether to not include any HTTP headers in the request',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'requestMapper',
      description: 'The function to call to map the request to the http request object',
      type: '(request: IHttpRequest) => IHttpRequest',
    },
    {
      name: 'responseMapper',
      description:
        'The function to call to map the data and paging info after it has been returned from the http request',
      type: '(response: IHttpResponse) => IHttpResponse',
    },
    {
      name: 'successEventName',
      description:
        'The event name to raise after a successful http call has been made. This will raise event with the name being the value of this prop',
      type: 'string',
    },
    {
      name: 'failureEventName',
      description:
        'The event name to raise after a failed http call has been made.This will raise event with the name being the value of this prop',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'responded',
      description: 'Raised on a response',
      parameters: [
        {
          name: 'headers',
          description: 'The HTTP headers',
          type: 'Headers',
        },
        {
          name: 'status',
          description: 'The HTTP status code',
          type: 'number',
        },
        {
          name: 'ok',
          description: 'Whether the request was successful',
          type: 'boolean',
        },
        {
          name: 'body',
          description: 'The HTTP body',
          type: 'any',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'setRequestHeader',
      description: 'Adds or sets and existing request HTTP header value',
      parameters: [
        {
          name: 'name',
          description: 'The HTTP header name',
          type: 'string',
        },
        {
          name: 'value',
          description: 'The HTTP header value',
          type: 'string',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'setRequestHeaders',
      description: 'Adds a collection of request HTTP headers',
      parameters: [
        {
          name: 'headers',
          description: 'Object literal containing the headers to set',
          type: '{ [key: string]: string }',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'setRequestBody',
      description: 'Sets the body for the http request',
      parameters: [
        {
          name: 'body',
          description: 'Object literal containing the body to set',
          type: 'any',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'clearRequestHeaders',
      description: 'Removes all the request headers',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'makeHttpCall',
      description: 'Makes the http request',
      parameters: [
        {
          name: 'body',
          description: 'The request body',
          type: 'IHttpRequest',
        },
      ],
      returnType: 'void',
    },
  ],
  stories: [SWCharacterFinderStory, SWDropDownStory, AccessTokenStory, ResponseMapperStory],
};
